import ApiClient from './ApiClient'

export default class JobBoardServices {

  constructor() {
    this.apiClient = new ApiClient()
  }

  getPublicJobs() {
    return this.apiClient.create().get('/job-board/public')
  }

  submitEnquiry(jobId, enquiry) {
    return this.apiClient.createAuthed().post('/job-board/enquire', { jobId, message: enquiry })
  }

}